import { Dialog, Text } from '@leroy-merlin-br/backyard-react-ui'

import { deleteClient, finishProject } from './services'

const handleModal = (setModal, id, status) => {
  const modalDeleteClient = ({ onClose }) => (
    <Dialog
      title="Tem certeza que deseja excluir esse cliente?"
      onClose={onClose}
      actions={[
        { color: 'green', content: 'Voltar', onClick: onClose },
        {
          content: 'Excluir cliente',
          onClick: () => deleteClient(id, onClose)
        }
      ]}
    >
      <Text size="mega" noMargin>
        Ao excluir esse cliente ele desaparecerá da lista de clientes com
        projetos concluídos.
      </Text>
    </Dialog>
  )

  const modalCancelProject = ({ onClose }) => (
    <Dialog
      title="Tem certeza que deseja finalizar esse projeto?"
      onClose={onClose}
      actions={[
        { color: 'green', content: 'Voltar', onClick: onClose },
        {
          content: 'Finalizar projeto',
          onClick: () => finishProject(id, onClose)
        }
      ]}
    >
      <Text size="mega" noMargin>
        Ao finalizar o projeto, você não poderá mais enviar cupons nem ganhar
        bônus pelas compras deste cliente.
      </Text>
    </Dialog>
  )

  const STATUS_TYPE = ['pendente', 'finalizado', 'concluído']

  if (STATUS_TYPE.includes(status)) {
    return setModal({ appElement: 'body', size: 'giga', children: modalDeleteClient })
  }

  return setModal({ appElement: 'body', size: 'giga', children: modalCancelProject })
}

export default handleModal
